

import { motion } from 'framer-motion';
import { MessageSquare, AlertCircle } from 'lucide-react';

export default function Problem() {
  return (
    <section className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Text Content */}
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <h2 className="text-3xl sm:text-4xl font-bold text-primary mb-6">
              The reality most teams live with
            </h2>
            <div className="space-y-6 text-lg text-text-muted">
              <p>
                Support wants to give developers everything they need.
                Developers want to solve problems, not play detective.
                Everyone's doing their best.
              </p>
              <p className="font-semibold text-primary">
                But under pressure, details get missed.
              </p>
              <ul className="list-disc pl-5 space-y-2">
                <li>Reproduction steps</li>
                <li>Severity levels</li>
                <li>Context that matters</li>
              </ul>
              <p>
                Then comes the back-and-forth:
                <br />
                <span className="italic">"Can you clarify...?"</span>
                <br />
                <span className="italic">"What did you mean by...?"</span>
              </p>
              <p>It's frustrating for everyone.</p>
            </div>
          </motion.div>

          {/* Visual Content */}
          <motion.div
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="relative"
          >
            <div className="bg-white rounded-xl shadow-lg border border-gray-200 p-6 max-w-md mx-auto transform rotate-1 hover:rotate-0 transition-transform duration-300">
              <div className="flex items-center gap-3 border-b border-gray-100 pb-4 mb-4">
                <div className="w-8 h-8 bg-red-100 rounded-full flex items-center justify-center text-red-500">
                  <AlertCircle size={18} />
                </div>
                <div>
                  <div className="text-sm font-semibold text-gray-900">BUG-1024: Login failing</div>
                  <div className="text-xs text-gray-500">Opened 2 days ago</div>
                </div>
              </div>
              
              <div className="space-y-4">
                <div className="bg-gray-50 p-3 rounded text-sm text-gray-600">
                  <p>Customer says they can't login. Fixing ASAP.</p>
                </div>

                <div className="pl-4 border-l-2 border-gray-200 space-y-4">
                  <div className="flex gap-3">
                    <div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center text-blue-600 flex-shrink-0 text-xs font-bold">DV</div>
                    <div className="bg-white border border-gray-200 p-3 rounded-lg text-sm shadow-sm w-full">
                      <p className="text-gray-800 font-medium mb-1">Dev Team</p>
                      <p className="text-gray-600">Which user? What browser? I can't repro this locally.</p>
                    </div>
                  </div>

                  <div className="flex gap-3">
                    <div className="w-8 h-8 bg-green-100 rounded-full flex items-center justify-center text-green-600 flex-shrink-0 text-xs font-bold">SP</div>
                    <div className="bg-white border border-gray-200 p-3 rounded-lg text-sm shadow-sm w-full">
                      <p className="text-gray-800 font-medium mb-1">Support</p>
                      <p className="text-gray-600">Asking the customer now...</p>
                    </div>
                  </div>
                  
                  <div className="flex gap-2 items-center text-xs text-gray-400 italic justify-center pt-2">
                    <MessageSquare size={14} />
                    <span>12 more comments...</span>
                  </div>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
